/**
 * @author jakubmaslon
 * @since 2020-11-19
 */

import * as React from "react";
import styled, { css } from "styled-components";
import { Colors } from "@batmaid/design-tokens";

import { Heading } from "@ui/Atoms/Headings";
import { rem } from "@ui/helpers";

interface Props {
  title: string;
  color?: keyof Colors;
  variant?: "heading" | "caption";
  className?: string;
}

const PriceTitle = ({
  variant = "heading",
  ...props
}: Props): React.ReactElement => (
  <TitleContainer className={props.className}>
    {variant === "caption" && (
      <PriceTitleSubtitle color={props.color}>{props.title}</PriceTitleSubtitle>
    )}

    {variant === "heading" && (
      <Title type="h5" color={props.color}>
        {props.title}
      </Title>
    )}
  </TitleContainer>
);

export { PriceTitle };

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled(Heading)<{ color?: string }>`
  display: inline-block;
  font-size: ${props => props.theme.fonts.sizes.body};
  font-weight: ${props => props.theme.fonts.weights.bold};
  text-transform: uppercase;
  margin-bottom: 0;
  margin-right: auto;
  color: ${props => props.color || props.theme.palette.grey800};
  line-height: ${rem(24)};
`;

const PriceTitleSubtitle = styled.span<{ color?: keyof Colors }>`
  display: inline-block;
  font-size: ${props => props.theme.fonts.sizes.caption};
  line-height: ${props => props.theme.fonts.sizes.body2};
  padding-bottom: ${props => props.theme.margins.half};
  margin-right: auto;
  color: ${props => props.theme.palette.grey800};

  ${props =>
    !!props.color &&
    css`
      color: ${props.theme.palette[props.color]};
    `}
`;
